import classNames from 'classnames';
import { useCssInJs } from "../../../../../hooks";
import { useTaskDetailDrawer } from "../../TaskDetail";
import { ReactComponent as IconTaskRunning } from "./icon-task-running.svg";
import { ReactComponent as IconTaskStop } from "./icon-task-stop.svg";
import { getStyles } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var STATUS_MAP = {
  审批中: 'DOING',
  完成: 'FINISHED',
  中止: 'SUSPEND',
  DOING: '审批中',
  FINISHED: '完成',
  SUSPEND: '中止'
};
var TaskProgress = function TaskProgress(props) {
  var _data$flowOrders;
  var prefix = 'legacy-form-progress';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var openTaskDetail = useTaskDetailDrawer();
  var data = props.data,
    mode = props.mode,
    onFinish = props.onFinish;
  if (mode === 'editable' || !((_data$flowOrders = data.flowOrders) !== null && _data$flowOrders !== void 0 && _data$flowOrders.length)) {
    return null;
  }
  var handleClick = function handleClick(flowOrder) {
    var flowOrderId = flowOrder.flowOrderId,
      taskOrderId = flowOrder.taskOrderId;
    openTaskDetail({
      flowOrderId: flowOrderId,
      taskOrderId: taskOrderId
    }).catch(function () {
      return void 0;
    }).finally(function () {
      return onFinish();
    });
  };
  var flowOrders = data.flowOrders;
  return wrapSSR( /*#__PURE__*/_jsxs("div", {
    className: classNames(prefix, hashId),
    children: [/*#__PURE__*/_jsx("div", {
      className: "section-title",
      children: "\u6D41\u7A0B\u8FDB\u5EA6"
    }), flowOrders.map(function (item) {
      var flowOrderCode = item.flowOrderCode,
        flowOrderName = item.flowOrderName,
        flowOrderStatus = item.flowOrderStatus,
        curTask = item.currentTaskOrder,
        createTime = item.createTime,
        finishTime = item.finishTime;
      if (!flowOrderCode) {
        return null;
      }
      var isStopped = [STATUS_MAP.完成, STATUS_MAP.中止].includes(flowOrderStatus || '');
      return /*#__PURE__*/_jsxs("div", {
        className: "item",
        onClick: function onClick() {
          return handleClick(item);
        },
        children: [isStopped ? /*#__PURE__*/_jsx(IconTaskStop, {
          className: "icon"
        }) : /*#__PURE__*/_jsx(IconTaskRunning, {
          className: "icon"
        }), /*#__PURE__*/_jsxs("div", {
          className: "content",
          children: [/*#__PURE__*/_jsx("div", {
            className: "title",
            children: flowOrderName || '-'
          }), curTask ? /*#__PURE__*/_jsxs("div", {
            className: "help",
            children: ["\u5F53\u524D\u8282\u70B9: ", curTask.nodeName || '-']
          }) : null, finishTime ? /*#__PURE__*/_jsxs("div", {
            className: "help",
            children: [finishTime, " \u5DF2\u5B8C\u6210"]
          }) : null, createTime ? /*#__PURE__*/_jsxs("div", {
            className: "help helpLight",
            children: [createTime, " \u521B\u5EFA"]
          }) : null]
        })]
      }, flowOrderCode);
    })]
  }));
};
export default TaskProgress;